import { createEvent, createStore } from 'effector';

export const setRecalculateStoreInProcess = createEvent<boolean>();
export const $recalculateInProcess = createStore<boolean>(false).on(
  setRecalculateStoreInProcess,
  (_, p) => p,
);
